/**
 * Stella theme manifest.
 *
 * Sun-glow gradient (warm yellow → coral pink) with gold accents and a
 * stylized fairy/sun-ray motif. Inspired by sunrise palettes; original art
 * — no Winx Club / Iginio Straffi IP referenced.
 *
 * Requirement compliance:
 * - 7.1 — exposes `accentPink` (#ff6b9e).
 * - 7.2 — paired display/body typography.
 * - 7.3 / 8.4 / 8.6 — animation durations within 150–600 ms / ≤600 ms / ≤1500 ms.
 * - 8.1 — selectable as a built-in theme.
 * - 8.7 — id is the persistence key.
 * - 8.8 — IP-safe: original sun-ray and fairy-wing motifs, abstracted.
 * - 10.1 / 10.4 — `textPrimary` on light surface meets WCAG 2.1 AA contrast;
 *   `focusRing` meets the 3:1 non-text contrast bar.
 *
 * Pure module: no runtime side effects on import; SVG art lazy-loaded via
 * Vite `?url` thunks so each theme lives in its own chunk (Property 28).
 */

import type { ThemeManifest } from '../types';

export const stellaManifest: ThemeManifest = {
  id: 'stella',
  displayName: { tr: 'Stella', en: 'Stella', el: 'Stella' },
  colors: {
    bgGradient: ['#ffd76b', '#ff7e9e'],
    surface: '#fff8e7',
    textPrimary: '#2a1d05',
    textSecondary: '#7b5d2a',
    accentPink: '#ff6b9e',
    accentSecondary: '#ffd700',
    bubbleUser: '#ffb74b',
    bubbleAssistant: '#fff8e7',
    focusRing: '#ff6b9e',
  },
  typography: {
    display: '"Playfair Display", Georgia, serif',
    body: '"Inter", "Segoe UI", system-ui, sans-serif',
  },
  assets: {
    backgroundArt: () => import('./background.svg?url'),
    characterArt: () => import('./stella.png?url'),
  },
  animation: {
    bubbleIn: {
      duration: 240,
      easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
      type: 'transform',
    },
    characterIdle: {
      duration: 1200,
      easing: 'ease-in-out',
      type: 'transform',
      loop: true,
      enabled: true,
    },
    crossfadeMs: 480,
  },
};
